import React from "react";

interface TnrmModalProps {
  show: boolean;
  /** "add" or "remove" — controls the title and body text. */
  mode: "add" | "remove";
  /** Whether the operation is in progress. */
  isProcessing?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * TNRM confirmation dialog matching the MVC Kendo Dialog exactly:
 *   Add title:    "Add to TNRM"
 *   Add body:     "Are you sure you want to add to TNRM the selected phone numbers?"
 *   Remove title: "Remove TNRM"
 *   Remove body:  "Are you sure you want to remove TNRM the selected phone numbers?"
 *   Buttons: Cancel (secondary) + Ok (primary)
 */
const TnrmModal: React.FC<TnrmModalProps> = ({
  show,
  mode,
  isProcessing = false,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  const isAdd = mode === "add";

  return (
    <div
      className="modal d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" style={{ maxWidth: 500 }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {isAdd ? "Add to TNRM" : "Remove TNRM"}
            </h5>
            <button type="button" className="btn-close" onClick={onCancel} disabled={isProcessing} />
          </div>
          <div className="modal-body">
            {isProcessing ? (
              <div className="d-flex align-items-center gap-2">
                <span className="spinner-border spinner-border-sm" />
                <span>{isAdd ? "Adding to TNRM..." : "Removing from TNRM..."}</span>
              </div>
            ) : (
              <p>
                Are you sure you want to {isAdd ? "add to" : "remove"} TNRM the selected phone numbers?
              </p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={isProcessing}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isProcessing}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TnrmModal;
